import ApiHelper from "@/scripts/api/ApiHelper.js";

let activePaletteCache = [];
let adminPaletteCache = [];

export async function fetchColorPalettes({ includeDeleted = false, forceRefresh = false } = {}) {
    const targetCache = includeDeleted ? adminPaletteCache : activePaletteCache;
    if (!forceRefresh && targetCache.length) {
        return targetCache;
    }

    const endpoint = includeDeleted ? "/api/admin/color-palettes" : "/api/color-palettes";
    const { data } = await ApiHelper.getWithParams(endpoint, includeDeleted ? { includeDeleted: true } : {});
    const palettes = (data || []).map((palette) => ({
        ...palette,
        deletedAt: palette.deletedAt || null
    }));

    if (includeDeleted) {
        adminPaletteCache = palettes;
    } else {
        activePaletteCache = palettes;
    }

    return palettes;
}

export async function createColorPalette(payload) {
    const { data } = await ApiHelper.post("/api/admin/color-palettes", payload);
    activePaletteCache = [];
    adminPaletteCache = [];
    return { ...data, deletedAt: data.deletedAt || null };
}

export async function updateColorPalette(paletteId, payload) {
    const { data } = await ApiHelper.put(`/api/admin/color-palettes/${paletteId}`, payload);
    activePaletteCache = [];
    adminPaletteCache = [];
    return { ...data, deletedAt: data.deletedAt || null };
}

export async function archiveColorPalette(paletteId) {
    const { data } = await ApiHelper.patch(`/api/admin/color-palettes/${paletteId}/archive`);
    activePaletteCache = [];
    adminPaletteCache = [];
    return { ...data, deletedAt: data.deletedAt || null };
}

export async function restoreColorPalette(paletteId) {
    const { data } = await ApiHelper.patch(`/api/admin/color-palettes/${paletteId}/restore`);
    activePaletteCache = [];
    adminPaletteCache = [];
    return { ...data, deletedAt: data.deletedAt || null };
}
